import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { errorToast, successToast, toast } from 'helpers';
import i18n from 'locales/i18n';
interface InitialState {
  settingsShopCustom: Array<{
    name: string;
    active: number;
    app_name: number[];
  }>;
  listServices: Array<any>;
}
const initialState: InitialState = {
  settingsShopCustom: [
    {
      name: 'show_order_web_order',
      active: 0,
      app_name: [3],
    },
  ],
  listServices: [],
};

const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    getSettingsShopCustom(
      state,
      action: PayloadAction<{ shop_id: number; bill_id: number | string; appName: string }>
    ) {},
    getSettingsShopCustomSuccess(state, action: PayloadAction<any>) {
      state.settingsShopCustom = action.payload;
    },
    getServices(state, action: PayloadAction<{ shop_id: number; appName: string }>) {},
    getServicesSuccess(state, action: PayloadAction<Array<any>>) {
      const filterServiceByApp = action.payload.filter((item) => item.app_name.includes('3'));
      state.listServices = filterServiceByApp;
    },
    getServicesFailed(state) {
      state.listServices = initialState.listServices;
    },
    callStaffServices(_, action: PayloadAction<{ token: string; data: any; appName: string }>) {},
    callStaffServicesSuccess() {
      successToast(i18n.t('UPDATED'));
    },
    callStaffServicesFailed(_, action: PayloadAction<string>) {
      const message = action.payload;
      if (message == 'token_order_expired') {
        errorToast(i18n.t('RELOAD_OR_SCAN_AGAIN_TO_ORDER'));
      } else {
        errorToast(i18n.t('UPDATED_FAILED'));
      }
    },
  },
});

// Actions
export const settingsAction = settingsSlice.actions;

// Reducer
const settingsReducer = settingsSlice.reducer;
export default settingsReducer;
